import type { CrossJoinIntegraton } from '@atlassian/cross-join-nudges';

import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

type StatsigExperimentKey =
	| 'cross_join_nudges_v3_experiment'
	| 'cross_join_nudges_confluence_to_jpd_experiment';

export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';

export const getExperimentCohort = (
	integration: CrossJoinIntegraton,
	{ fireExposure } = {
		fireExposure: false,
	},
) => {
	try {
		const [expConfig, fireExperimentExposure] = getStatsigExperiment(integration);
		fireExposure && fireExperimentExposure();
		return expConfig.get('cohort', 'not-enrolled');
	} catch {
		return NOT_ENROLLED;
	}
};

export const isExperimentEnabled = (integration: CrossJoinIntegraton) =>
	getExperimentCohort(integration, { fireExposure: false }) === VARIATION;

export const getExperimentKey = (integration: CrossJoinIntegraton): StatsigExperimentKey => {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return 'cross_join_nudges_v3_experiment';
		case 'crossJoinNudgesConfluenceToJpd':
			return 'cross_join_nudges_confluence_to_jpd_experiment';
	}
};

const getStatsigExperiment = (integration: CrossJoinIntegraton) => {
	switch (integration) {
		case 'crossJoinNudgesV3':
			return UNSAFE_noExposureExp('cross_join_nudges_v3_experiment');
		case 'crossJoinNudgesConfluenceToJpd':
			return UNSAFE_noExposureExp('cross_join_nudges_confluence_to_jpd_experiment');
	}
};
